<template>
    <v-container class="pa-0 ma-0">
        <v-card class="pa-0 ma-0">
            <v-card-title class="headline head-einvoice-config">
                <span class="text-h6 primary__blue py-1 ml-2">Configuración de {{nameToShow}}</span>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text>
                <v-tabs v-model="activeTab">
                    <v-tab v-for="tab in filteredTabs" :key="tab.name">{{tab.name}}</v-tab>
                </v-tabs>

                <v-tabs-items v-model="activeTab">
                    <v-tab-item v-for="tab in filteredTabs" :key="tab.code">
                        <template v-if="tab.code == 'sequences'">
                            <v-row class="pt-4">
                                <v-col cols="2"><span class="font-weight-bold pb-0">Tipo</span></v-col>
                                <v-col cols="3"><span class="font-weight-bold pb-0">Nombre Secuencia</span></v-col>
                                <v-col cols="1"><span class="font-weight-bold pb-0">Prefijo</span></v-col>
                                <v-col cols="1"><span class="font-weight-bold pb-0">Relleno</span></v-col>
                                <v-col cols="1"><span class="font-weight-bold pb-0">Sufijo</span></v-col>
                                <v-col cols="1"><span class="font-weight-bold pb-0">Próx. número</span></v-col>
                                <v-col cols="2"><span class="font-weight-bold pb-0">Siguiente Identificador</span></v-col>
                                <v-col cols="1"></v-col>
                            </v-row>
                            <template v-for="(sequence, index) in configuration.sequences">
                                <v-row v-if="!sequence.deleted" :key="'seq-' + index" :class="{'sequence-disabled': sequence.disabled}">
                                    <v-col cols="2" class="font-weight-bold pl-5 align-self-center font-12 pb-0">
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on, attrs }">
                                                <div class="text-truncate" v-bind="attrs" v-on="on">
                                                    {{nameToShow}}
                                                    <span v-if="sequence.is_for_recurring_contracts">
                                                        (Recurrente)
                                                    </span>
                                                </div>
                                            </template>
                                            <span>
                                                {{nameToShow}}
                                                <span v-if="sequence.is_for_recurring_contracts">
                                                    (Recurrente)
                                                </span>
                                            </span>
                                        </v-tooltip>
                                    </v-col>
                                    <v-col cols="3" class="pb-0">
                                        <v-tooltip bottom :disabled="!(!sequence.code || !sequence.code.trim() || sequence.duplicateError )">
                                            <template v-slot:activator="{ on, attrs }">
                                            <!-- label="Nombre secuencia" -->
                                                <v-text-field
                                                    class="config-invoice-text-field"
                                                    v-model="sequence.code"                                            
                                                    outlined
                                                    dense
                                                    hide-details="auto"
                                                    :error="!sequence.code || !sequence.code.trim() || sequence.duplicateError"
                                                    :readonly="sequence.disabled"
                                                    v-bind="attrs"
                                                    v-on="on"
                                                ></v-text-field>
                                                </template>
                                                <template v-if="!sequence.code || !sequence.code.trim()">Campo requerido</template>
                                                <template v-else-if="sequence.duplicateError">Nombre de secuencia duplicado</template>
                                                
                                        </v-tooltip>
                                      </v-col>                                      
                                    <v-col cols="1" class="pb-0">
                                        <!--  label="Prefijo" -->
                                        <v-tooltip bottom :disabled="!(sequence.normalComboError || hasSpecialChars(sequence.prefix))">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-text-field
                                                    class="config-invoice-text-field"
                                                    v-model="sequence.prefix"
                                                    outlined
                                                    dense
                                                    hide-details
                                                    :readonly="sequence.disabled || (Boolean(sequence.id) && sequence.min_number!=-1)"
                                                    :error="!!sequence.normalComboError || hasSpecialChars(sequence.prefix)"
                                                    v-bind="attrs"
                                                    v-on="on"
                                                ></v-text-field>
                                            </template>
                                            <span v-if="hasSpecialChars(sequence.prefix)">No se permiten caracteres especiales</span>
                                            <span v-else-if="sequence.normalComboError">Hay combinaciones (Prefijo+Sufijo) repetidas.</span>
                                        </v-tooltip>
                                    </v-col>
                                    <v-col cols="1" class="pb-0">
                                        <!-- label="Relleno" -->
                                        <v-tooltip bottom :disabled="!!sequence.fill || sequence.fill === 0">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-text-field
                                                    class="config-invoice-text-field"
                                                    v-model="sequence.fill"                                            
                                                    outlined
                                                    dense
                                                    hide-details="auto"
                                                    :type="'number'"
                                                    :error="sequence.fill === null || sequence.fill === undefined || sequence.fill.toString().trim() === ''"
                                                    :readonly="sequence.disabled"
                                                    v-bind="attrs"
                                                    v-on="on"
                                                ></v-text-field>
                                            </template>
                                            <span>Campo requerido</span>
                                        </v-tooltip>
                                    </v-col>
                                    <v-col cols="1" class="pb-0">
                                        <!-- label="Sufijo" -->
                                        <v-tooltip bottom :disabled="!(sequence.normalComboError || hasSpecialChars(sequence.suffix))">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-text-field
                                                    class="config-invoice-text-field"
                                                    v-model="sequence.suffix"
                                                    outlined
                                                    dense
                                                    hide-details
                                                    :readonly="sequence.disabled || (Boolean(sequence.id) && sequence.min_number!=-1)"
                                                    :error="!!sequence.normalComboError || hasSpecialChars(sequence.suffix)"
                                                    v-bind="attrs"
                                                    v-on="on"
                                                ></v-text-field>
                                            </template>
                                            <span v-if="hasSpecialChars(sequence.suffix)">No se permiten caracteres especiales</span>
                                            <span v-else-if="sequence.normalComboError">Hay combinaciones (Prefijo+Sufijo) repetidas.</span>
                                        </v-tooltip>
                                            
                                    </v-col>
                                    <v-col cols="1" class="pb-0">                                       
                                        <v-tooltip bottom :disabled="!(!next[index] || sequence.min_number != -1 && next && next[index] <= sequence.min_number)">
                                            <template v-slot:activator="{ on, attrs }">
                                                <!-- Proximo numero-->
                                                <v-text-field
                                                    class="config-invoice-text-field"
                                                    v-model="next[index]"                                                    
                                                    outlined
                                                    dense
                                                    hide-details="auto"
                                                    type="number"
                                                    :error="!next[index] || Number(next[index]) <= 0 || (sequence.min_number != -1 && next && next[index] <= sequence.min_number)"
                                                    :readonly="sequence.disabled"
                                                    v-bind="attrs"
                                                    v-on="on"
                                                ></v-text-field>
                                            </template>
                                            <span>
                                                <template v-if="!next[index]">
                                                    Valor requerido
                                                </template>
                                                <template v-else-if="Number(next[next]) <= 0">
                                                    El valor debe ser mayor que 0
                                                </template>
                                                <template v-else-if="sequence.min_number != -1 && next && next[index] <= sequence.min_number">
                                                    Valor inferior al mínimo permitido ({{ sequence.min_number + 1 }})
                                                </template>
                                            </span>
                                        </v-tooltip>
                                    </v-col>                                
                                    
                                    <v-col cols="2" class="align-self-center font-12 pb-0"><div class="pl-2">{{ previewNum(index) }}</div></v-col>
                                    <v-col cols="1" class="align-self-center pb-0">
                                        <div class="d-flex justify-end no-wrap">
                                            <v-tooltip bottom :disabled="sequence.disabled">
                                                <template v-slot:activator="{ on, attrs }">
                                                    <div v-bind="attrs" v-on="on" style="display: inline-block;">
                                                        <v-btn
                                                            icon
                                                            small
                                                            color="error"
                                                            @click="removeSequence(index)"
                                                            :disabled="!canRemoveSequence(sequence) || sequence.disabled"
                                                        >
                                                            <v-icon small>mdi-delete</v-icon>
                                                        </v-btn>
                                                    </div>
                                                </template>
                                                <span v-if="canRemoveSequence(sequence)">Eliminar serie</span>
                                                <span v-else>No se puede eliminar una serie con facturas emitidas</span>
                                            </v-tooltip>
                                            <!-- disable/enable option -->
                                            <v-tooltip bottom>
                                                <template v-slot:activator="{ on, attrs }">
                                                    <div v-bind="attrs" v-on="on" style="display: inline-block;">
                                                        <v-btn
                                                            icon
                                                            small
                                                            color="primary_blue"
                                                            @click="toggleSequenceStatus(index)"
                                                        >
                                                            <v-icon small>
                                                                {{ sequence.disabled ? 'mdi-check-circle-outline' : 'mdi-close-circle-outline' }}
                                                            </v-icon>
                                                        </v-btn>
                                                    </div>
                                                </template>
                                                <span>
                                                    {{ sequence.disabled ? 'Habilitar serie' : 'Deshabilitar serie' }}
                                                </span>
                                            </v-tooltip>
                                            <v-menu offset-y :disabled="sequence.disabled">
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-btn
                                                        icon
                                                        small
                                                        v-bind="attrs"
                                                        v-on="on"
                                                        :disabled="sequence.disabled"
                                                    >
                                                        <v-icon small>mdi-dots-vertical</v-icon>
                                                    </v-btn>
                                                </template>
                                                <v-list>
                                                    <v-list-item @click="assignTemplateToSequence(index)">
                                                        <v-list-item-icon>
                                                            <v-icon>mdi-file-document-outline</v-icon>
                                                        </v-list-item-icon>
                                                        <v-list-item-content>
                                                            <v-list-item-title>Asignar plantilla</v-list-item-title>
                                                        </v-list-item-content>
                                                    </v-list-item>
                                                </v-list>
                                            </v-menu>
                                        </div>
                                    </v-col>
                                </v-row>                                
                                <v-row v-if="invoiceableType === 'invoice' && !sequence.deleted" :key="'rect-' + index" :class="{'sequence-disabled': sequence.disabled}">
                                    <v-col cols="2" class="font-weight-bold font-12">
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on, attrs }">
                                                <div class="align-self-center pl-2 config-rectificative-field text-truncate" v-bind="attrs" v-on="on">
                                                    F. Rectificativa
                                                    <span v-if="sequence.is_for_recurring_contracts">
                                                        (Recurrente)
                                                    </span>
                                                </div>
                                            </template>
                                            <span>
                                                F. Rectificativa
                                                <span v-if="sequence.is_for_recurring_contracts">
                                                    (Recurrente)
                                                </span>
                                            </span>
                                        </v-tooltip>
                                    </v-col>
                                    <v-col cols="3">
                                        <v-tooltip bottom :disabled="!(!sequence.rectificative_code || !sequence.rectificative_code.trim() || sequence.rectDuplicateError)">
                                          <template v-slot:activator="{ on, attrs }">
                                            <!-- label="Nombre secuencia rectificativa" -->
                                            <v-text-field
                                              class="config-rectificative-text-field"
                                              v-model="sequence.rectificative_code"                                            
                                              outlined
                                              dense
                                              hide-details="auto"
                                              :error="!sequence.rectificative_code || !sequence.rectificative_code.trim() || sequence.rectDuplicateError"
                                              :readonly="sequence.disabled"
                                              v-bind="attrs"
                                              v-on="on"
                                            ></v-text-field>
                                          </template>
                                          <span>
                                            <template v-if="!sequence.rectificative_code || !sequence.rectificative_code.trim()">Campo requerido</template>
                                            <template v-else-if="sequence.rectDuplicateError">Nombre de secuencia duplicado</template>
                                        </span>
                                        </v-tooltip>
                                    </v-col>
                                    <v-col cols="1">
                                        <!-- Prefijo rectificativas -->
                                        <v-tooltip bottom :disabled="!(sequence.rectComboError || hasSpecialChars(sequence.rectificative_prefix))">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-text-field
                                                    class="config-rectificative-text-field"
                                                    v-model="sequence.rectificative_prefix"
                                                    outlined
                                                    dense
                                                    hide-details
                                                    :readonly="sequence.disabled || (Boolean(sequence.id) && sequence.min_rectificative_number!=-1)"
                                                    :error="!!sequence.rectComboError || hasSpecialChars(sequence.rectificative_prefix)"
                                                    v-bind="attrs"
                                                    v-on="on"
                                                ></v-text-field>
                                            </template>
                                            <span v-if="hasSpecialChars(sequence.rectificative_prefix)">No se permiten caracteres especiales</span>
                                            <span v-else-if="sequence.rectComboError">Hay combinaciones (Prefijo+Sufijo) repetidas.</span>
                                        </v-tooltip>
                                    </v-col>
                                    <v-col cols="1">
                                        <!-- Relleno rectificativas -->
                                        <v-tooltip bottom :disabled="!!sequence.rectificative_fill || sequence.rectificative_fill === 0">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-text-field
                                                    class="config-rectificative-text-field"
                                                    v-model="sequence.rectificative_fill"                                            
                                                    outlined
                                                    dense
                                                    hide-details="auto"
                                                    :type="'number'"
                                                    :error="sequence.rectificative_fill === null || sequence.rectificative_fill === undefined || sequence.rectificative_fill.toString().trim() === ''"
                                                    :readonly="sequence.disabled"
                                                    v-bind="attrs"
                                                    v-on="on"
                                                ></v-text-field>
                                            </template>
                                            <span>Campo requerido</span>
                                        </v-tooltip>
                                    </v-col>
                                    <v-col cols="1">
                                        <!--  label="Sufijo rectificativas" -->
                                        <v-tooltip bottom :disabled="!(sequence.rectComboError || hasSpecialChars(sequence.rectificative_suffix))">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-text-field
                                                    class="config-rectificative-text-field"
                                                    v-model="sequence.rectificative_suffix"
                                                    outlined
                                                    dense
                                                    hide-details
                                                    :readonly="sequence.disabled || (Boolean(sequence.id) && sequence.min_rectificative_number!=-1)"
                                                    :error="!!sequence.rectComboError || hasSpecialChars(sequence.rectificative_suffix)"
                                                    v-bind="attrs"
                                                    v-on="on"
                                                ></v-text-field>
                                            </template>
                                            <span v-if="hasSpecialChars(sequence.rectificative_suffix)">No se permiten caracteres especiales</span>
                                            <span v-else-if="sequence.rectComboError">Hay combinaciones (Prefijo+Sufijo) repetidas.</span>
                                        </v-tooltip>
                                    </v-col>
                                    <v-col cols="1">
                                        <v-tooltip bottom :disabled="!(!rectificative_next[index] || sequence.min_rectificative_number != -1 && rectificative_next <= sequence.min_rectificative_number)">
                                            <template v-slot:activator="{ on, attrs }">
                                                <!--label="Próximo número rectificativas" -->
                                                <v-text-field
                                                    class="config-rectificative-text-field"
                                                    v-model="rectificative_next[index]"                                                    
                                                    outlined
                                                    dense
                                                    hide-details="auto"
                                                    type="number"
                                                    :error="!rectificative_next[index] || Number(rectificative_next[index]) <= 0 ||  (sequence.min_rectificative_number != -1 && rectificative_next <= sequence.min_rectificative_number)"
                                                    :readonly="sequence.disabled"
                                                    v-bind="attrs"
                                                    v-on="on"
                                                ></v-text-field>
                                            </template>
                                            <span>
                                                <template v-if="!rectificative_next[index]">
                                                    Valor requerido
                                                </template>
                                                <template v-else-if="Number(next[rectificative_next]) <= 0">
                                                    El valor debe ser mayor que 0
                                                </template>
                                                <template v-else-if="sequence.min_rectificative_number != -1 && rectificative_next && rectificative_next[index] <= sequence.min_rectificative_number">
                                                    Valor inferior al mínimo permitido ({{ sequence.min_rectificative_number + 1 }})
                                                </template>
                                            </span>
                                        </v-tooltip>
                                    </v-col>
                                    <v-col cols="2" class="align-self-center font-12 primary__blue"> <div class="pl-2 config-rectificative-field">{{ previewRectificativeNum(index) }}</div></v-col>
                                </v-row>
                                
                            </template>
                            <v-btn class="btn-add-serie mt-2" @click="addNewSequence(false)" outlined>
                                <v-icon left>
                                    mdi-plus
                                </v-icon>
                                Añadir Serie
                            </v-btn>
                            <v-btn class="btn-add-serie mt-2 ml-2" @click="addNewSequence(true)"
                                outlined v-if="invoiceableType === 'invoice'">
                                <v-icon left>
                                    mdi-plus
                                </v-icon>
                                Añadir Serie Recurrente
                            </v-btn>

                        </template>

                        <template v-else-if="tab.code == 'custom_image'">
                            <!-- New user-friendly template editor for users with feature_custom_invoice_templates -->
                            <template v-if="has_invoice_template_editor">
                                <CustomInvoiceTemplateEditor
                                    :configuration="configuration"
                                    :companyId="String(companydb_id)"
                                    @update:logo="file = $event; dirty = true;"
                                    @update:footer="configuration.footer = $event; dirty = true;"
                                    @update:footer_small="configuration.footer_small = $event; dirty = true;"
                                    @template-saved="onTemplateSaved"
                                />
                            </template>

                            <!-- Original simple version for users without the feature -->
                            <template v-else>
                                <v-row>
                                    <v-col cols="7">
                                        <v-select
                                            v-if="!isEditingTemplateName"
                                            v-model="selectedTemplate"
                                            :items="templates"
                                            item-text="name"
                                            item-value="id"
                                            label="Plantilla"
                                            outlined
                                            dense
                                            hide-details="auto"
                                            @change="onTemplateChange"
                                        >
                                            <template v-slot:prepend-inner>
                                                <v-icon color="primary">mdi-palette</v-icon>
                                            </template>
                                        </v-select>
                                        <v-text-field
                                            v-else
                                            v-model="editingTemplateName"
                                            label="Nombre de la plantilla"
                                            outlined
                                            dense
                                            hide-details="auto"
                                            autofocus
                                            @keyup.enter="saveTemplateName"
                                            @keyup.esc="cancelEditTemplateName"
                                        >
                                            <template v-slot:prepend-inner>
                                                <v-icon color="primary">mdi-palette</v-icon>
                                            </template>
                                        </v-text-field>
                                    </v-col>
                                    <v-col cols="3" class="d-flex align-center">
                                        <template v-if="!isEditingTemplateName">
                                            <v-tooltip bottom>
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-btn
                                                        icon
                                                        color="primary"
                                                        @click="startEditTemplateName"
                                                        :disabled="!selectedTemplate"
                                                        v-bind="attrs"
                                                        v-on="on"
                                                    >
                                                        <v-icon>mdi-pencil</v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>Editar plantilla</span>
                                            </v-tooltip>
                                            <v-tooltip bottom>
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-btn
                                                        icon
                                                        color="primary"
                                                        @click="addNewTemplate"
                                                        v-bind="attrs"
                                                        v-on="on"
                                                    >
                                                        <v-icon>mdi-plus</v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>Nueva plantilla</span>
                                            </v-tooltip>
                                            <v-tooltip bottom>
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-btn
                                                        icon
                                                        color="error"
                                                        @click="deleteTemplate"
                                                        :disabled="!selectedTemplate || templates.length <= 1"
                                                        v-bind="attrs"
                                                        v-on="on"
                                                    >
                                                        <v-icon>mdi-delete</v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>Eliminar plantilla</span>
                                            </v-tooltip>
                                        </template>
                                        <template v-else>
                                            <v-btn
                                                icon
                                                color="success"
                                                @click="saveTemplateName"
                                                :disabled="!editingTemplateName || !editingTemplateName.trim()"
                                            >
                                                <v-icon>mdi-check</v-icon>
                                            </v-btn>
                                            <v-btn
                                                icon
                                                color="error"
                                                @click="cancelEditTemplateName"
                                            >
                                                <v-icon>mdi-close</v-icon>
                                            </v-btn>
                                        </template>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col>
                                        <v-file-input
                                            label="Logo"
                                            v-model="file"
                                            outlined
                                            dense
                                            prepend-icon=""
                                            name="uploader"
                                            accept=".jpg, .png, .jpeg"
                                            class="file-input--outlined rounded-lg"
                                            @click="dirty = true;"
                                            hide-details="auto"
                                            :disabled="!isEditingPersonalization"
                                        >
                                            <template #prepend-inner>
                                            <v-icon color="primary" left>
                                                mdi-paperclip
                                            </v-icon>
                                            </template>
                                        </v-file-input>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col>
                                        <v-img
                                            v-if="configuration.path_url"
                                            :src="configuration.path_url"
                                            class="d-inline-block"
                                            max-width="300"
                                            max-height="300"
                                            contain
                                        ></v-img>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col>
                                        <v-textarea
                                            v-model="configuration.footer"
                                            outlined
                                            dense
                                            :label="'Pie de ' + nameToShow"
                                            hide-details="auto"
                                            rows="2"
                                            :readonly="!isEditingPersonalization"
                                        ></v-textarea>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col>
                                        <v-textarea
                                            v-model="configuration.footer_small"
                                            outlined
                                            dense
                                            :label="'Pie de ' + nameToShow + ', letra pequeña'"
                                            hide-details="auto"
                                            rows="2"
                                            :readonly="!isEditingPersonalization"
                                        ></v-textarea>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col>
                                        <v-text-field
                                            v-model="configuration.alias"
                                            outlined
                                            dense
                                            :label="'Nombre Comercial (Opcional)'"
                                            hide-details="auto"
                                            :readonly="!isEditingPersonalization"
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                            </template>
                        </template>

                        <template v-else-if="tab.code == 'email_template' && configuration.email_template">
                            <v-row>
                                <v-col>
                                    <v-text-field
                                        label="Asunto"
                                        v-model="configuration.email_template.subject"
                                        outlined
                                        dense
                                        hide-details="auto"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col>
                                    <v-textarea
                                        v-model="configuration.email_template.message"
                                        outlined
                                        dense
                                        label="Mensaje"
                                        hide-details="auto"
                                        rows="3"
                                    ></v-textarea>
                                </v-col>
                            </v-row>
                        </template>

                        <template v-else-if="tab.code == 'remittance'">
                            <v-row class="pt-2 px-4">
                                <v-col cols="12">
                                    <v-checkbox
                                        v-model="configuration.remittance_only_iban"
                                        label="Generar remesas solo con IBAN (sin mandato SEPA)"
                                        hint="Si se activa, no se requerirá el ID de mandato SEPA ni la fecha de firma del receptor para generar remesas. Solo se necesitará el IBAN."
                                        persistent-hint
                                        hide-details="auto"
                                        class="mt-0"
                                        color="primary_blue"
                                    ></v-checkbox>
                                </v-col>
                            </v-row>
                        </template>
                    </v-tab-item>
                </v-tabs-items>
                
                    
                
            </v-card-text>
            <v-card-actions class="pr-8 pb-5">
                <v-spacer></v-spacer>
                <v-btn outlined @click="cancel()" class="action__btn">Cancelar</v-btn>
                <v-btn
                    color="primary_blue"
                    class="white--text action__btn"
                    @click="save()"
                    :disabled="!allowSave"
                >
                    Guardar
                </v-btn>
            </v-card-actions>
        </v-card>

        <!-- Delete Template Confirmation Dialog -->
        <v-dialog v-model="showDeleteDialog" max-width="500" persistent>
            <v-card>
                <v-card-title class="headline head-einvoice-config">
                    Eliminar plantilla
                </v-card-title>
                <v-card-text class="pt-4">
                    <div v-if="deleteError" class="mb-4">
                        <v-alert type="error" dense text>
                            {{ deleteError }}
                        </v-alert>
                    </div>
                    <div v-else-if="isDeleting" class="text-center py-4">
                        <v-progress-circular
                            indeterminate
                            color="primary"
                            size="48"
                        ></v-progress-circular>
                        <div class="mt-3">Eliminando plantilla...</div>
                    </div>
                    <div v-else>
                        ¿Está seguro de que desea eliminar esta plantilla?
                    </div>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="closeDeleteDialog" :disabled="isDeleting">{{ deleteError ? 'Cerrar' : 'Cancelar' }}</v-btn>
                    <v-btn
                        v-if="!deleteError"
                        color="error"
                        text
                        @click="confirmDeleteTemplate"
                        :loading="isDeleting"
                        :disabled="isDeleting"
                    >
                        Eliminar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Assign Template to Sequence Dialog -->
        <v-dialog v-model="showTemplateAssignDialog" max-width="500">
            <v-card>
                <v-card-title class="headline head-einvoice-config">
                    Asignar plantilla a serie
                </v-card-title>
                <v-card-text class="pt-4">
                    <v-select
                        v-model="templateToAssign"
                        :items="templates"
                        item-text="name"
                        item-value="id"
                        label="Seleccionar plantilla"
                        outlined
                        dense
                        clearable
                        placeholder="Ninguna plantilla (usar configuración general)"
                    ></v-select>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="showTemplateAssignDialog = false">Cancelar</v-btn>
                    <v-btn color="primary" text @click="confirmAssignTemplate">Asignar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

    </v-container>
</template>

<script>
// import { Company } from '@/modules/facturae/domain/Company';
import { Sequence, validateCodeSequences, validatePrefixSuffixSequences, validateNextNumber } from '@/modules/facturae/domain/Sequence';
import { mapGetters, mapState } from "vuex";
import Vue from 'vue'
import { Configuration } from '@/modules/facturae/domain/Configuration';
import CustomInvoiceTemplateEditor from '@/components/CustomInvoiceTemplateEditor.vue';
import { DeleteTemplateCommand } from '@/modules/facturae/app/DeleteTemplateCommand';
import { APITemplateRepository } from '@/modules/facturae/infra/ApiTemplateRepository';


export default {
    name: 'EInvoiceConfig',
    components: {
        CustomInvoiceTemplateEditor
    },
    props:{
        configuration: {
            type: [Object, Configuration],
            required: true,
            default: null
        },
        invoiceableType: {
            type: String,
            required: false,
            default: 'invoice'
        },
        templates: {
            type: Array,
            required: false,
            default: () => []
        },
    },
    data(){
        return {
            next: [],
            rectificative_next: [],
            file: null,
            dirty: false,
            activeTab:null,
            tabs: [
                {code: "sequences", "name": "Series"},
                {code: "custom_image", "name": "Personalización de imagen"},
                {code: "email_template", "name": "Plantilla envio"},
                {code: "remittance", "name": "Remesas", onlyInvoice: true}
            ],
            selectedTemplate: null,
            isEditingTemplateName: false,
            editingTemplateName: '',
            isNewTemplate: false,
            isEditingPersonalization: false,
            showDeleteDialog: false,
            deleteError: null,
            isDeleting: false,
            showTemplateAssignDialog: false,
            selectedSequenceIndex: null,
            templateToAssign: null,
            originalConfigBackup: null,
            originalSelectedTemplate: null
        }
    },
    async mounted(){
        if(this.configuration.sequences){
            for (let seq in this.configuration.sequences){
                Vue.set(this.next, seq, Number.parseInt(this.configuration.sequences[seq].current) +1)
                Vue.set(this.rectificative_next, seq, Number.parseInt(this.configuration.sequences[seq].rectificative_current) +1)
            }
        }
        if (this.got_feature('feature_manual_invoice_number') || this.invoiceableType === 'proforma') {
            this.tabs = [
                {code: "custom_image", "name": "Personalización de imagen"},
                {code: "email_template", "name": "Plantilla envio"}
            ]
            this.activeTab = "custom_image"
        }

        // Select the template: use configuration.personalization_id if set, otherwise use the first template in the list
        if (this.configuration.personalization_id) {
            this.selectedTemplate = this.configuration.personalization_id;
        } else if (this.templates && this.templates.length > 0) {
            this.selectedTemplate = this.templates[0].id;
        }

        // Save the original selected template
        this.originalSelectedTemplate = this.selectedTemplate;

        // Load the selected template data if needed
        if (this.selectedTemplate && !this.configuration.name) {
            this.onTemplateChange(this.selectedTemplate);
        }
    },
    methods:{
        hasSpecialChars(value) {
            if (!value) return false;
            return /[*+?^${}()|[\]\\]/.test(value);
        },
        hasAnySpecialChars() {
            for (let seq of this.configuration.sequences) {
                if (this.hasSpecialChars(seq.prefix) || this.hasSpecialChars(seq.suffix) ||
                    this.hasSpecialChars(seq.rectificative_prefix) || this.hasSpecialChars(seq.rectificative_suffix)) {
                    return true;
                }
            }
            return false;
        },
        async save(){
            if (this.hasAnySpecialChars()) {
                return;
            }
            if (!validateCodeSequences(this.configuration.sequences, this.invoiceableType)){
                return;
            }
            if (!validatePrefixSuffixSequences(this.configuration.sequences, this.invoiceableType)){
                return;
            }
            for (let seq in this.configuration.sequences){
                this.configuration.sequences[seq].current = Number.parseInt(this.next[seq]) - 1;
                this.configuration.sequences[seq].rectificative_current = Number.parseInt(this.rectificative_next[seq]) - 1;
            }

            // If creating a new template, ensure personalization_id is null
            if (this.isNewTemplate) {
                this.configuration.personalization_id = null;
                if (this.editingTemplateName && this.editingTemplateName.trim()) {
                    this.configuration.name = this.editingTemplateName.trim();
                }
            }

            this.$emit('save-config', {'file': this.file, 'dirty': this.dirty});

            // Reset editing state
            this.isEditingTemplateName = false;
            this.isNewTemplate = false;
            this.isEditingPersonalization = false;
        },
        onTemplateSaved(){
            // Template was saved by CustomInvoiceTemplateEditor
            // The template is already saved in the backend, so we don't mark dirty
            // We emit the event to parent so it can reload the configuration if needed
            this.$emit('template-saved');
        },
        cancel(){
            // Revert sequences
            for (let seq in this.configuration.sequences){
                if (this.configuration.sequences[seq]) {
                    this.next[seq] = Number.parseInt(this.configuration.sequences[seq].current) +1;
                    this.rectificative_next[seq] = Number.parseInt(this.configuration.sequences[seq].rectificative_current) +1;
                }
            }

            // Revert selected template
            this.selectedTemplate = this.originalSelectedTemplate;

            // Load the template data from the templates list
            if (this.selectedTemplate) {
                this.onTemplateChange(this.selectedTemplate);
            }

            // Reset editing states
            this.isEditingTemplateName = false;
            this.isNewTemplate = false;
            this.isEditingPersonalization = false;
            this.file = null;
            this.dirty = false;

            this.$emit('cancel');
        },
        previewNum(index){
            if (this.next[index] && this.configuration.sequences[index]) {
                let num = this.next[index];
                return `${this.configuration.sequences[index].prefix}${num.toString().padStart(this.configuration.sequences[index].fill, '0')}${this.configuration.sequences[index].suffix}`;
            }
        },
        previewRectificativeNum(index){
            if (this.rectificative_next[index] && this.configuration.sequences[index]) {
                let num = this.rectificative_next[index];
                return `${this.configuration.sequences[index].rectificative_prefix}${num.toString().padStart(this.configuration.sequences[index].rectificative_fill, '0')}${this.configuration.sequences[index].rectificative_suffix}`;
            }
        },
        addNewSequence(is_for_recurring_contracts) {
            let seq = new Sequence();
            seq.company_id = this.configuration.company_id
            if (is_for_recurring_contracts) {
                seq.is_for_recurring_contracts = true
            }
            this.configuration.sequences.push(seq)
        },
        canRemoveSequence(sequence) {
            // Una secuencia se puede eliminar si no tiene facturas creadas
            // Esto se determina si min_number === -1 (y min_rectificative_number === -1 para facturas)
            if (this.invoiceableType === 'invoice') {
                return sequence.min_number === -1 && sequence.min_rectificative_number === -1;
            }
            return sequence.min_number === -1;
        },
        removeSequence(index) {
            // Marcar la secuencia como eliminada en lugar de quitarla del array
            this.$set(this.configuration.sequences[index], 'deleted', true);
        },
        onTemplateChange(templateId) {
            // Load the selected template data and update configuration
            const template = this.templates.find(t => t.id === templateId);

            if (template) {
                // Update configuration with template data
                this.configuration.personalization_id = template.id;
                this.configuration.name = template.name;
                this.configuration.footer = template.footer;
                this.configuration.footer_small = template.footer_small;
                this.configuration.path = template.path;
                this.configuration.path_url = template.path_url;
                this.configuration.alias = template.alias || '';
            }
            this.$emit('template-changed', templateId);
        },
        startEditTemplateName() {
            // Start editing the current template name and personalization fields
            const currentTemplate = this.templates.find(t => t.id === this.selectedTemplate);
            if (currentTemplate) {
                this.editingTemplateName = currentTemplate.name;
                this.isEditingTemplateName = true;
                this.isNewTemplate = false;
                this.isEditingPersonalization = true;
            }
        },
        addNewTemplate() {
            // Start creating a new template
            this.editingTemplateName = '';
            this.isEditingTemplateName = true;
            this.isNewTemplate = true;
            this.isEditingPersonalization = true;

            // Clear personalization fields for the new template
            this.configuration.personalization_id = null;
            this.configuration.name = '';
            this.configuration.footer = '';
            this.configuration.footer_small = '';
            this.configuration.path = null;
            this.configuration.path_url = null;
            this.configuration.alias = '';
            this.file = null;
        },
        saveTemplateName() {
            if (!this.editingTemplateName || !this.editingTemplateName.trim()) {
                return;
            }

            if (this.isNewTemplate) {
                // Creating new template - add temporary template with unique ID
                const tempId = 'temp_' + Date.now();
                const newTemplate = {
                    id: tempId,
                    name: this.editingTemplateName.trim()
                };
                this.templates.push(newTemplate);
                this.selectedTemplate = tempId; // Select the temporary template

                // Mark that we need to save this as a new template
                this.configuration.personalization_id = null;  // Clear ID for new template (backend will assign real ID)
                this.configuration.name = this.editingTemplateName.trim();
            } else {
                // Editing existing template name
                const template = this.templates.find(t => t.id === this.selectedTemplate);
                if (template) {
                    template.name = this.editingTemplateName.trim();
                    // Update configuration name if editing
                    this.configuration.name = this.editingTemplateName.trim();
                }
            }

            this.isEditingTemplateName = false;
            this.editingTemplateName = '';
            // Keep isEditingPersonalization true so fields remain editable
        },
        cancelEditTemplateName() {
            // Cancel editing
            this.isEditingTemplateName = false;
            this.editingTemplateName = '';
            this.isNewTemplate = false;
            this.isEditingPersonalization = false;
        },
        deleteTemplate() {
            if (!this.selectedTemplate) {
                return;
            }

            // Don't allow deleting if it's the only template
            if (this.templates.length <= 1) {
                return;
            }

            // Reset error state and show confirmation dialog
            this.deleteError = null;
            this.showDeleteDialog = true;
        },
        closeDeleteDialog() {
            this.showDeleteDialog = false;
            this.deleteError = null;
            this.isDeleting = false;
        },
        async confirmDeleteTemplate() {
            // Find the template to delete
            const templateIndex = this.templates.findIndex(t => t.id === this.selectedTemplate);
            if (templateIndex === -1) {
                this.closeDeleteDialog();
                return;
            }

            const templateId = this.selectedTemplate;

            try {
                // Use the DeleteTemplateCommand with hexagonal architecture
                const templateRepo = new APITemplateRepository();
                const deleteCommand = new DeleteTemplateCommand(templateRepo, this);
                const result = await deleteCommand.execute(templateId, this.companydb_id, this.userData.id);

                console.log('[DEBUG confirmDeleteTemplate] Result:', result);

                // Check if the command returned success: false
                if (result && result.output && result.output.success === false) {
                    // Show error from command result
                    this.deleteError = result.output.error || 'No se puede eliminar esta plantilla';
                    return;
                }

                // Success - remove from local list
                this.templates.splice(templateIndex, 1);

                // Select another template (first one available)
                if (this.templates.length > 0) {
                    this.selectedTemplate = this.templates[0].id;
                    this.onTemplateChange(this.selectedTemplate);
                }

                // Close dialog
                this.closeDeleteDialog();
            } catch (error) {
                console.error('Error deleting template:', error);

                // Show error message in the dialog
                let errorMessage = 'Error al eliminar la plantilla';
                if (error.message) {
                    errorMessage = error.message;
                } else if (error.response && error.response.data && error.response.data.message) {
                    errorMessage = error.response.data.message;
                }

                // Check if it's the specific error about sequences
                if (errorMessage.includes('siendo utilizada') || errorMessage.includes('configuraciones') || errorMessage.includes('serie')) {
                    this.deleteError = errorMessage;
                } else {
                    this.deleteError = errorMessage;
                }
            }
        },
        assignTemplateToSequence(sequenceIndex) {
            // Open dialog to assign template to sequence
            this.selectedSequenceIndex = sequenceIndex;

            // Pre-select the template if the sequence already has one
            if (this.configuration.sequences[sequenceIndex].personalization_id) {
                this.templateToAssign = this.configuration.sequences[sequenceIndex].personalization_id;
            } else {
                this.templateToAssign = null;
            }

            this.showTemplateAssignDialog = true;
        },
        confirmAssignTemplate() {
            if (this.selectedSequenceIndex !== null) {
                // Assign the template to the sequence (can be null to unassign)
                Vue.set(this.configuration.sequences[this.selectedSequenceIndex], 'personalization_id', this.templateToAssign);

                // Close dialog
                this.showTemplateAssignDialog = false;
                this.selectedSequenceIndex = null;
                this.templateToAssign = null;
            }
        },
        toggleSequenceStatus(index) {
            // Toggle the disabled status of a sequence
            const currentStatus = this.configuration.sequences[index].disabled;
            this.$set(this.configuration.sequences[index], 'disabled', !currentStatus);
        },
    },
    computed:{
        ...mapGetters({ got_feature: "got_feature",
                        userData: 'me/userData' }),
        ...mapState([
        'session_information',
        ]),
        companydb_id() {
            return this.$route.params.companydb_id || this.$store.state.current_company_id;
        },
        staff_or_loginas(){
            return (this.userData && this.userData.is_staff) || (this.session_information && this.userData.username && this.session_information.username != this.userData.username )
        },
        has_invoice_template_editor(){
            return this.got_feature('feature_custom_invoice_templates') && this.staff_or_loginas //mentre no estigui monetitzat com toca
        },
        allowSave() {
            let baseValid = this.configuration.sequences.every((seq, index) => {

                // console.log("------------------------------------------------")
                // console.log("seq.code", seq.code)
                // console.log("seq.code.trim()", seq.code.trim())
                // console.log("this.next[index]", this.next[index])
                // console.log("this.rectificative_next[index]", this.rectificative_next[index])
                // console.log("seq.fill", seq.fill)
                // console.log("seq.fill.toString().trim()", seq.fill.toString().trim())
                // console.log("seq.rectificative_fill", seq.rectificative_fill)
                // console.log("seq.rectificative_fill.toString().trim()", seq.rectificative_fill.toString().trim())
                // console.log("seq.rectificative_code", seq.rectificative_code)
                // console.log("seq.rectificative_code.trim()", seq.rectificative_code.trim())
                // console.log("this.rectificative_next[index]", this.rectificative_next[index])
                // console.log("seq.min_number", seq.min_number)
                // console.log("seq.min_number === -1", seq.min_number === -1)
                // console.log("this.next[index] > seq.min_number", this.next[index] > seq.min_number)
                // console.log("seq.min_rectificative_number", seq.min_rectificative_number)
                // console.log("seq.min_rectificative_number === -1", seq.min_rectificative_number === -1)
                // console.log("this.rectificative_next[index] > seq.min_rectificative_number", this.rectificative_next[index] > seq.min_rectificative_number)
                // --------------------------------------------------------------------------------------------------------------------------------------------------------
                // return seq.code && seq.code.trim() &&
                //         this.next[index] && validateNextNumber(this.next[index]) &&
                //         this.rectificative_next[index] && validateNextNumber(this.rectificative_next[index]) &&
                //         (seq.fill !== undefined && seq.fill.toString().trim() !== "") &&
                //         (seq.rectificative_fill !== undefined && seq.rectificative_fill.toString().trim() !== "") &&
                //         seq.rectificative_code && seq.rectificative_code.trim() &&
                //         this.rectificative_next[index] &&
                //         (seq.min_number === -1 || this.next[index] > seq.min_number) &&
                //         (seq.min_rectificative_number === -1 || this.rectificative_next[index] > seq.min_rectificative_number);
                // --------------------------------------------------------------------------------------------------------------------------------------------------------

                return seq.code && seq.code.trim() &&
                    this.next[index] && validateNextNumber(this.next[index]) &&
                    (seq.fill !== undefined && seq.fill.toString().trim() !== "") &&
                    (this.invoiceableType !== 'invoice' || 
                        (seq.rectificative_fill !== undefined && seq.rectificative_fill.toString().trim() !== "" &&
                        seq.rectificative_code && seq.rectificative_code.trim() &&
                        this.rectificative_next[index] && validateNextNumber(this.rectificative_next[index]) &&
                        (seq.min_rectificative_number === -1 || this.rectificative_next[index] > seq.min_rectificative_number))) &&
                    (seq.min_number === -1 || this.next[index] > seq.min_number);
            });

            // Disable save button if template name is being edited
            if (this.isEditingTemplateName) {
                return false;
            }

            if (this.invoiceableType !== 'proforma') {
                return baseValid && validateCodeSequences(this.configuration.sequences, this.invoiceableType) && validatePrefixSuffixSequences(this.configuration.sequences, this.invoiceableType)
            }
            return true
        },
        nameToShow() {
            switch (this.invoiceableType) {
                case 'invoice':
                    return 'Factura';
                case 'delivery_note':
                    return 'Albarán';
                case 'proforma':
                    return 'Proforma';
                case 'ticket':
                    return 'F. Simplificada';
                default:
                    return 'Presupuesto';
            }
        },
        filteredTabs() {
            return this.tabs.filter(tab => {
                // Si el tab tiene onlyInvoice: true, solo mostrarlo para facturas
                if (tab.onlyInvoice) {
                    return this.invoiceableType === 'invoice';
                }
                return true;
            });
        },
    }
}
</script>

<style>
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }
    .action__btn {
        font-weight: 500;
        font-size: 14px;
        line-height: 16px;
        border-radius: 20px;
        padding: 18px !important;
        gap: 8px;
        text-transform: capitalize;
    }

    .primary__blue {
        color: var(--v-primary_blue-base);
    }    
</style>

<style scoped>
.head-einvoice-config {
    background-color: color-mix(in srgb, var(--v-primaryLight-base) 20%, white);
    color: var(--v-primary_blue-base);
}
.btn-add-serie {
    text-transform: capitalize;
    font-weight: 500;
    font-size:12px;
    height: 22px !important;
    border-color: #AAA;
    color: #565656;
    border-radius:2px;

}
.config-rectificative-field {
    font-size:12px;
    background-color: #eeeeee !important;
    height: 40px;
    line-height: 40px;
    border-radius:2px;
}
.config-invoice-text-field {
    border-radius:2px;
    font-size:12px;
}

.config-invoice-text-field .v-messages__message {
    white-space: nowrap !important;
  }

.config-rectificative-text-field {
    font-size:12px;
    background-color: #eeeeee !important;
    border-radius:2px;
}

.font-12 {
    font-size:12px;
}

.text-truncate {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.v-messages__message {
    white-space: nowrap !important;
    text-overflow: ellipsis;
    overflow: hidden;
    display: block;
  }

.sequence-disabled {
    position: relative;
    opacity: 0.5;
    pointer-events: none;
}

.sequence-disabled::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(200, 200, 200, 0.3);
    pointer-events: none;
    z-index: 1;
}

.sequence-disabled .v-btn {
    pointer-events: auto;
    z-index: 2;
    position: relative;
}
  
</style>